<template>
    <div class="balance-based-payment-type">
        <div class="balance-item">
            <div class="balance-item-label">
                <img src="@/assets/images/icons/bank-card-line.svg">
                <span>Payed By Card</span>
            </div>
            <div class="balance-amount-widget">
                {{ $formatMoney(
                    cardAmount,
                    (decimalCount = 2),
                    (decimal = '.'),
                    (thousands = ','),
                    (currency = currency)
                ) }}
            </div>

        </div>
        <div class="balance-item">
            <div class="balance-item-label">
                <img src="@/assets/images/icons/cellphone-line.svg">
                <span>Payed By Mobile</span>
            </div>
            <div class="balance-amount-widget">
                {{ $formatMoney(
                    momoAmount,
                    (decimalCount = 2),
                    (decimal = '.'),
                    (thousands = ','),
                    (currency = currency)
                ) }}
            </div>
        </div>
        <div class="balance-item">
            <div class="balance-item-label">
                <img src="@/assets/images/icons/router-line.svg">
                <span>Payed By Spenn</span>
            </div>
            <div class="balance-amount-widget">
                {{ $formatMoney(
                    spennAmount,
                    (decimalCount = 2),
                    (decimal = '.'),
                    (thousands = ','),
                    (currency = currency)
                ) }}
            </div>
        </div>

    </div>
</template>

<script>
export default {
    components: {},
    sockets: {},
    props: {
        cardAmount: {
            type: [String, Number],
            default: 0,
        },
        momoAmount: {
            type: [String, Number],
            default: 0,
        },
        spennAmount: {
            type: [String, Number],
            default: 0,
        },
        currency: {
            type: String,
            default: "RWF",
        },
    },
    data: () => ({}),
    watch: {},
    mounted() {
        let vm = this;
    },
    methods: {

    },
};
</script>
<style lang="scss" scoped>
.balance-based-payment-type {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;
    justify-content: space-between;
    padding: 10px 10px;
    height: auto;

    @media (max-width: 860px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 638px) {
        grid-template-columns: 1fr;
    }



    .balance-item {
        border: 1px solid #ddd;
        border-radius: 10px;

        .balance-item-label {
            display: flex;
            border-bottom: 1px solid #ddd;
            padding: 10px;
            text-transform: uppercase;

            img {
                width: 20px;
                margin-right: 10px;
            }
        }

        .balance-amount-widget {
            padding: 10px;
            font-size: 30px;

            @media (max-width: 638px) {
                font-size: 22px;
            }
        }
    }
}
</style>